import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  conversationHistory: [],
  currentScriptSection: 'intro',
  currentStepIndex: 0,
  searchTerm: '',
  isInitialized: false,
  collectedInfo: {
    email: null,
    phoneNumber: null,
    backupPhoneNumber: null,
  },
};

const supportDeskSlice = createSlice({
  name: 'supportDesk',
  initialState,
  reducers: {
    setConversationHistory: (state, action) => {
      state.conversationHistory = action.payload;
    },
    addToConversationHistory: (state, action) => {
      state.conversationHistory.push(action.payload);
    },
    setCurrentScriptSection: (state, action) => {
      state.currentScriptSection = action.payload;
    },
    setCurrentStepIndex: (state, action) => {
      state.currentStepIndex = action.payload;
    },
    setSearchTerm: (state, action) => {
      state.searchTerm = action.payload;
    },
    setIsInitialized: (state, action) => {
      state.isInitialized = action.payload;
    },
    setCollectedInfo: (state, action) => {
      state.collectedInfo = { ...state.collectedInfo, ...action.payload };
    },
    resetSupportDesk: (state) => {
      state.conversationHistory = [];
      state.currentScriptSection = 'intro';
      state.currentStepIndex = 0;
      state.searchTerm = '';
      state.isInitialized = false;
      state.collectedInfo = {
        email: null,
        phoneNumber: null,
        backupPhoneNumber: null,
      };
    },
    initializeDefaultChat: (state, action) => {
      if (!state.isInitialized) {
        state.conversationHistory = action.payload.conversationHistory;
        state.currentStepIndex = action.payload.currentStepIndex;
        state.isInitialized = true;
      }
    },
  },
});

export const {
  setConversationHistory,
  addToConversationHistory,
  setCurrentScriptSection,
  setCurrentStepIndex,
  setSearchTerm,
  setIsInitialized,
  setCollectedInfo,
  resetSupportDesk,
  initializeDefaultChat,
} = supportDeskSlice.actions;

export default supportDeskSlice.reducer;